import React from 'react';
import { Paper, PaperProps, Typography } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function EmptyList({
  sx,
  text = 'Список пуст',
  ...other
}: PaperProps & { text?: string }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Paper
      elevation={4}
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: 1,
        py: sp.s90,
        px: sp.s70,
        borderRadius: '10px',
        ...sx,
      }}
      {...other}
    >
      <Typography variant="f18b">{text}</Typography>
    </Paper>
  );
}
